import * as validationLib from "../../lib/validation";
import cn from "../../lib/classnames";
import gradientStyles from "../../styles/Gradient.module.css";
import React from "react";
import styles from "./Checkbox.module.css";
import TextLink from "../TextLink";
import textStyles from "../../styles/Text.module.css";

type Props = React.ComponentProps<"input"> & {
    label: string;
    hasGradient?: boolean;
    isChecked: boolean;
    to?: string;
    href?: string;
    linkText?: string;
    className?: string;
    classNameLabel?: string;
    validationMessage?: string[];
    optionalFrontBoldLabel?: string;
};

function Checkbox(
    {
        label,
        hasGradient = false,
        isChecked,
        to,
        href,
        linkText,
        className,
        classNameLabel,
        validationMessage,
        optionalFrontBoldLabel,
        ...rest
    }: Props,
    ref: React.ForwardedRef<HTMLInputElement>,
) {
    return (
        <>
            <div
                className={cn(
                    hasGradient ? styles.gradientContainer : undefined,
                    hasGradient ? gradientStyles.grey : undefined,
                    className,
                )}
            >
                <label className={cn(textStyles.inputPlaceholder, styles.labelContainer)}>
                    <input
                        className={styles.input}
                        checked={isChecked}
                        {...rest}
                        type="checkbox"
                        ref={ref}
                    />
                    <div className={cn(styles.checkbox, isChecked ? styles.checked : undefined)} />
                    {optionalFrontBoldLabel ? (
                        <div className={cn(styles.label, classNameLabel)}>
                            <span className={styles.bold}>{optionalFrontBoldLabel}</span>
                            {label}
                        </div>
                    ) : (
                        <div className={cn(styles.label, classNameLabel)}>{label}</div>
                    )}
                </label>
                {linkText && (to || href) ? (
                    <TextLink
                        className={styles.link}
                        to={to}
                        href={href}
                        text={linkText}
                        openInSameTab={false}
                    />
                ) : null}
            </div>
            {validationMessage && validationMessage.length ? (
                <div className={cn(textStyles.inputError, styles.validation)}>
                    {validationLib.getDisplayString(validationMessage)}
                </div>
            ) : null}
        </>
    );
}

export default React.forwardRef<HTMLInputElement, Props>(Checkbox);
